import React from 'react'
import './NotFound.scss'
import notFound from '@assets/images/notFound.svg'
import big404 from '@assets/images/404.svg'
import workizLogo from '@assets/images/workiz-logo.svg'

const NotFound = () => {
    return (
        <div className="error-container">
            <div className="error-content">
                <img alt="Not found" src={notFound}/>
                <img className='big404' alt="404" src={big404}/>
                <span className="sub-title">The webpage you're trying to reach can't be found</span>
                <a 
                    href="https://www.workiz.com/features/online-booking/?utm_source=bookingv2_404" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="booking-link"
                >
                    Learn more about Workiz Online Booking
                </a>
            </div>
            <a 
                href="https://workiz.com/?utm_source=bookingv2_404" 
                target="_blank" 
                rel="noopener noreferrer"
                className="workiz-logo-link"
            >
                <img 
                    src={workizLogo}
                    alt="Workiz Logo" 
                    className="workiz-logo"
                />
            </a>
        </div>
    )
}

export default NotFound;

